import { PlatformPrimitives } from '../types/PlatformPrimitives';

/**
 * @group Constants

@summary
<blockquote>Default mobile platform primitives using React Native components.</blockquote>

@example
```typescript
const mobilePrimitives = MobileDefaults;
```

Note: Requires react-native and react-native-svg dependencies
 * @internal
 */
export const MobileDefaults: PlatformPrimitives = {
  View: 'View', // from react-native
  Text: 'Text', // from react-native
  Svg: 'Svg', // from react-native-svg
  Path: 'Path', // from react-native-svg
  Line: 'Line', // from react-native-svg
  G: 'G', // from react-native-svg
  Pressable: 'Pressable' // from react-native
}; 